// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"cb2c22ca","187":"9ce372bc","406":"de3a6b5e"}[chunkId] + ".chunk.js";
};